import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const StyledFormWrapper = styled.div`
    width: ${ (props) => {
        props.setMaxWidth ? '80%' : '100%';
       }
    };
    max-width: ${ (props) => {
            props.setMaxWidth ? '80%' : '100%';
        }
    };
`;

const StyledSection = styled.div`
    margin-bottom: 40px;

    &:last-of-type {
        border-bottom: none;
        margin-bottom: 0;
    }
`;

const Title = styled.h2`
    margin-bottom: 5px;
    font-size: 1.4em;
`;

const StyledRow = styled.div`
    display: flex;
    justify-content: space-between;
`;

const StyledItem = styled.div`
    flex: 1 0 auto;
    padding-right: 20px;

    &:last-child {
        padding-right: 0;
    }
`;

const StyledButtonWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    margin-top: 40px;
    flex-grow: 1;
`;

export const FormWrapper = (props) => {
    return (
        <StyledFormWrapper setMaxWidth={ props.setMaxWidth }>
            { props.children }
        </StyledFormWrapper>
    );
};

FormWrapper.defaultProps = {
    setMaxWidth: true,
};

FormWrapper.propTypes = {
    children: PropTypes.object.isRequired,
    setMaxWidth: PropTypes.bool,
};

export const Section = (props) => {
    const { title } = props;

    return (
        <StyledSection>
            { !!title &&
                <Title>{ title }</Title>
            }

            { props.children }
        </StyledSection>
    );
};

Section.propTypes = {
    children: PropTypes.oneOfType([
        PropTypes.array,
        PropTypes.object,
    ]).isRequired,
    title: PropTypes.string,
};

export const Row = (props) => {
    return (
        <StyledRow>
            { props.children }
        </StyledRow>
    );
};

Row.propTypes = {
    children: PropTypes.oneOfType([
        PropTypes.array,
        PropTypes.object,
    ]).isRequired,
};

export const Item = (props) => {
    return (
        <StyledItem>
            { props.children }
        </StyledItem>
    );
};

Item.propTypes = {
    children: PropTypes.object.isRequired,
};

export const ButtonWrapper = (props) => {
    return (
        <StyledButtonWrapper>
            { props.children }
        </StyledButtonWrapper>
    );
};

ButtonWrapper.propTypes = {
    children: PropTypes.oneOfType([
        PropTypes.array,
        PropTypes.object,
    ]).isRequired,
};



// WEBPACK FOOTER //
// ./src/components/ui/table/elements.js